import { render, staticRenderFns } from "./BadgeUi.vue?vue&type=template&id=10063588&scoped=true&"
import script from "./BadgeUi.vue?vue&type=script&lang=js&"
export * from "./BadgeUi.vue?vue&type=script&lang=js&"
import style0 from "./BadgeUi.vue?vue&type=style&index=0&id=10063588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10063588",
  null
  
)

export default component.exports